module.exports = __webpack_public_path__ + "img/1121955783.48e1e79c.png";